import MovementSerializer from "../serializers/MovementSerializer";
import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";

export default class MovementRepository {
  MOVEMENT_BASE = "/api/movement";
  MOVEMENTS_BASE = "/api/movements";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getConfirmationTemplates(instance) {
    const token = await getToken(instance);
    const path = `${this.MOVEMENTS_BASE}/confirmationTemplates`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.templates);
  }

  async sendConfirmation(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.MOVEMENT_BASE}/sendConfirmation`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    }, false, true);

    return Promise.resolve(req);
  }

  async sendConfirmationEmail(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.MOVEMENT_BASE}/sendConfirmationEmail`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    }, false, true);

    return Promise.resolve(req);
  }

  async updateMovement(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.MOVEMENT_BASE}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ movement: MovementSerializer.serialize(payload) })
    });

    return Promise.resolve(MovementSerializer.deSerialize(req.movement));
  }

  async getMaxPay(instance, orderId) {
    const token = await getToken(instance);
    const path = `${this.MOVEMENT_BASE}/fetchoverridemaxpay?orderId=${orderId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers,
    });

    if (req.overrideMaxPay) {
      return Promise.resolve(req.overrideMaxPay);
    } else {
      return Promise.resolve({});
    }
  }
}